const NEW_SITE_WIDTH = 1280;
const BEFORE_MIGRATION_START_LABEL = 'BEFORE_SITE_WIDTH_MIGRATION';
const MIGRATION_FLOWS = {
  SITE_CREATION: 'siteCreation',
  SECTIONS_MIGRATION: 'sectionsMigration',
} as const;

export { NEW_SITE_WIDTH, MIGRATION_FLOWS, BEFORE_MIGRATION_START_LABEL };
